document.addEventListener("DOMContentLoaded", function () {

  function Accordion(el, multiple) {
    this.el = el;
    this.multiple = multiple || false;

    const links = this.el.querySelectorAll(".article-title");

    links.forEach(link => {
      link.addEventListener("click", (e) => this.dropdown(e));
    });
  }

 Accordion.prototype.dropdown = function (e) {
  e.preventDefault();
  e.stopPropagation();

  const container = e.currentTarget.closest(".accordion-container");
  const content = container.querySelector(".accordion-content");

  if (!content) return;

  const isOpen = content.style.display === "block";

  // close all
  if (!this.multiple) {
    document.querySelectorAll(".accordion-content").forEach(item => {
      item.style.display = "none";
      item.closest(".content-entry")?.classList.remove("open");
    });
  }

  // toggle current
  content.style.display = isOpen ? "none" : "block";
  container.querySelector(".content-entry").classList.toggle("open", !isOpen);
};

  document.querySelectorAll(".accordion-container").forEach(container => {
    new Accordion(container, false);
  });

  document.addEventListener("click", function (event) {
    document.querySelectorAll(".accordion-container").forEach(acc => {
      if (acc.contains(event.target)) return;

      acc.querySelectorAll(".open").forEach(item => {
        item.classList.remove("open");
        const content = item.querySelector(".accordion-content");
        if (content) content.style.display = "none";
      });
    });
  });

});